var map = {
	"./algethar-academy.jpg": 6660,
	"./kings-rest.jpg": 2692,
	"./pit-of-saron.jpg": 6714,
	"./ruby-life-pools.jpg": 6366,
	"./seat-of-the-triumvirate.jpg": 3809,
	"./skyreach.jpg": 7415,
	"./temple-of-sethraliss.jpg": 7475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4987;